import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('CompanyRelation', CompanyRelationData);

  CompanyRelationData.$inject = ['$translate', '$filter', 'LegalEntity', 'Seller'];

  /* @ngInject */
  function CompanyRelationData($translate, $filter, LegalEntity, Seller) {
    CompanyRelation.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      getDematMode: getDematMode,
      getLadType: getLadType,
      getAllowedTransmissions: getAllowedTransmissions,
      getAllowedDemats: getAllowedDemats
    };

    function CompanyRelation(CompanyRelationData) {
      if (!CompanyRelationData) {
        this.buildEmpty();
      } else {
        this.build(CompanyRelationData);
      }
    }

    return CompanyRelation;

    /////////////////////

    function buildEmpty() {
      this.principalName = null;
      this.buyer = new LegalEntity();
      this.seller = new Seller();
      this.acceptation = null;
      this.endOfValidity = null;
      this.ladType = null;
      this.dematMode = null;
      this.allowedTransmissionChannels = null;
      this.allowedDematModes = null;
      this.creationDate = null;
    }

    function build(relationData) {
      this.principalName = relationData.principalName || null;
      this.buyer = new LegalEntity(relationData.buyer);
      this.seller = new Seller(relationData.seller);
      this.acceptation = relationData.acceptation ? $filter('date')(relationData.acceptation, 'shortDate') : null;
      this.endOfValidity = relationData.endOfValidity || null;
      this.ladType = relationData.ladType || null;
      this.dematMode = relationData.dematMode || null;
      this.allowedTransmissionChannels = relationData.allowedTransmissionChannels;
      this.allowedDematModes = relationData.allowedDematModes;
      this.creationDate = relationData.creationDate ? $filter('date')(relationData.creationDate, 'shortDate') : null;
    }

    function getDematMode() {
      if (this.dematMode) {
        return translateDematMode(this.dematMode);
      }
      return '';
    }

    function getLadType() {
      if (this.ladType) {
        return translateLadType(this.ladType);
      }
      return '';
    }

    function getAllowedTransmissions() {
      var val = '';
      if (this.allowedTransmissionChannels) {
        val = _.map(this.allowedTransmissionChannels, function(trans) {
          return translateTransChannel(trans);
        }).join(' ou ');
      }
      return val;
    }

    function getAllowedDemats() {
      var val = '';
      if (this.allowedDematModes) {
        val = _.map(this.allowedDematModes, function(mode) {
          return translateDematMode(mode);
        }).join(' ou ');
      }
      return val;
    }

    function translateLadType(type) {
      return $translate.instant('principal.lad_types.' + angular.lowercase(type));
    }

    function translateDematMode(mode) {
      return $translate.instant('principal.demat_mode.' + angular.lowercase(mode));
    }

    function translateTransChannel(mode) {
      return $translate.instant('principal.transmission_mode.' + angular.lowercase(mode));
    }
  }
})();
